export enum RESOLUTION_STATUS_PERMISSIONS {
  RESOLUTION_STATUS_VIEW = 'INCIDENCE_RESOLUTIONSTATUSVIEW',
  RESOLUTION_STATUS_WRITE = 'INCIDENCE_RESOLUTIONSTATUSWRITE',
}
